<script setup>
import { computed } from 'vue';

const props = defineProps({
  file: { type: Object, required: true },
});

const isImage = computed(() => props.file.contentType?.startsWith('image/'));
const isAudio = computed(() => props.file.contentType?.startsWith('audio/'));

const formattedSize = computed(() => {
  const bytes = props.file.byteSize || 0;
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
});
</script>

<template>
  <a
    v-if="isImage"
    :href="file.url"
    target="_blank"
    rel="noopener noreferrer"
    class="block"
  >
    <img
      :src="file.thumbUrl || file.url"
      :alt="file.filename"
      class="rounded-lg max-w-[220px] max-h-[220px] object-cover"
    />
  </a>
  <audio v-else-if="isAudio" :src="file.url" controls class="max-w-[260px]" />
  <a
    v-else
    :href="file.url"
    target="_blank"
    rel="noopener noreferrer"
    class="flex items-center gap-2 px-3 py-2 rounded-lg bg-n-alpha-1 hover:bg-n-alpha-2 transition-colors max-w-[260px]"
  >
    <span class="i-lucide-file text-lg text-n-slate-11 shrink-0" />
    <span class="min-w-0 flex flex-col">
      <span class="text-sm text-n-slate-12 truncate">{{ file.filename }}</span>
      <span class="text-xs text-n-slate-11">{{ formattedSize }}</span>
    </span>
  </a>
</template>
